import { render, staticRenderFns } from "./c-notification-edit.vue?vue&type=template&id=950a704c&scoped=true&"
import script from "./c-notification-edit.vue?vue&type=script&lang=js&"
export * from "./c-notification-edit.vue?vue&type=script&lang=js&"
import style0 from "./c-notification-edit.vue?vue&type=style&index=0&id=950a704c&lang=scss&scoped=true&"
import style1 from "./c-notification-edit.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "950a704c",
  null
  
)

export default component.exports